import React from 'react';
import {createRoot} from 'react-dom/client';
import PexMapApp from "./PexMapApp";
import {I18nextProvider} from "react-i18next";
import i18n from '@apps/Shared/translation/i18n';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const container = document.getElementById('js-pexmap')!;
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
            <PexMapApp/>
        </I18nextProvider>
    </QueryClientProvider>
);